export default __webpack_public_path__ + "static/char-s-17-cht-940ba444d3e631072ca348bf61a5534a.png";